import {
  canAccessAgentPage,
  canAccessAccountsPage,
  canAccessMapPage,
  canAccessNonPeoplePages,
  canAccessProductSurfaces,
  isAdminUser,
} from './utils/userRoles';

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin: isAdminUser(currentUser),
    canUseProducts: canAccessProductSurfaces(currentUser),
    canUseAccounts: canAccessAccountsPage(currentUser),
    canUseMap: canAccessMapPage(currentUser),
    canUseAgent: canAccessAgentPage(currentUser),
    canUseNonPeoplePages: canAccessNonPeoplePages(currentUser),
  };
}
